import { render, staticRenderFns } from "./DialogLoad.vue?vue&type=template&id=5e2b9712"
import script from "./DialogLoad.vue?vue&type=script&lang=js"
export * from "./DialogLoad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports